import { toInternal } from '@models/form-customization';
import { FormModel } from '@models/form-model';
import { Button } from 'antd';
import React from 'react';
import { getPdfUrl } from '@api/formsApi';

type Props = {
  onBack: () => any;
  onEdit: () => any;
  editable?: boolean;
  form: FormModel;
  customerId: number;
};

const CustomizationDetailsView: React.FC<Props> = ({
  onBack,
  onEdit,
  editable = true,
  form,
  customerId,
}) => {
  const customs = toInternal(form.form_customizations);

  return (
    <>
      <label>Veterinarians</label>
      {customs.veterinarians.map((v, i) => (
        <div key={i}>{v}</div>
      ))}
      {customs.veterinarians.length === 0 && <div>No veterinarians</div>}
      <br />
      <label>Special Test Requests Notes</label>
      <div className="CustomizationDetails-notes">{customs.notes}</div>
      {customs.notes.length === 0 && <div>No notes</div>}
      <br />
      <label>Selected Test Codes</label>
      {customs.codes.map((t) => (
        <div key={t.name} className="CustomizationDetails-codes">
          {t.name} {t.id == null && '(unavailable)'}
        </div>
      ))}
      {customs.codes.length === 0 && <div>No codes</div>}
      <br />
      <div className="btn-group">
        <Button onClick={onBack}>Back</Button>
        <Button type="primary" onClick={onEdit} disabled={!editable}>
          Edit
        </Button>
        <Button
          href={getPdfUrl(customerId, form.id)}
          type="primary"
          target="_blank"
          className="btn-secondary"
        >
          Get PDF
        </Button>
      </div>
    </>
  );
};

export default CustomizationDetailsView;
